import type { AxiosResponse } from "axios";
import type { ApiResponse, PaginatedResponse } from "../types/api.types";

export class ApiContractError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ApiContractError";
  }
}

export const assertApiSuccess = <T>(
  response: AxiosResponse<ApiResponse<T>>,
): ApiResponse<T> => {
  const envelope = response.data;
  if (!envelope || envelope.success !== true) {
    throw new ApiContractError(
      envelope?.message || "La API devolvió una respuesta no exitosa",
    );
  }
  return envelope;
};

export const unwrapApiData = <T>(
  response: AxiosResponse<ApiResponse<T>>,
): T => {
  const envelope = assertApiSuccess(response);
  if (envelope.data === undefined || envelope.data === null) {
    throw new ApiContractError("La respuesta de la API no contiene datos");
  }
  return envelope.data;
};

export const unwrapApiList = <T>(
  response: AxiosResponse<ApiResponse<T[] | PaginatedResponse<T>>>,
): T[] => {
  const data = unwrapApiData(response);
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.data)) return data.data;
  throw new ApiContractError("La API no devolvió una lista válida");
};
